import React from 'react';

import CountryNameValue from 'components/atoms/CountryNameValue';
import Address from 'types/models/address';

function AddressSummary({
  address: { line1, line2, city, postCode, state, country }
}: {
  address: Address;
}) {
  return (
    // mb-24 to match the margin-bottom of DefaultFormItem
    <div className="mb-24">
      {line1 && <div className="body-copy">{line1}</div>}
      {line2 && <div className="body-copy">{line2}</div>}
      {(city || state || postCode) && (
        <div className="body-copy">
          {city}
          {state ? ` ${state.abbreviation},` : ''}
          {postCode ? ` ${postCode}` : ''}
        </div>
      )}
      <div className="body-copy">
        <CountryNameValue countryAbbreviation={country} />
      </div>
    </div>
  );
}

export default AddressSummary;
